import React from "react";
import { Route } from "react-router-dom";

import ShippingReturns from "../pages/utility/shippingReturns";
import PackagingDeliveryPolicy from "../pages/utility/packagingDeliveryPolicy";
import FAQArtist from "../pages/utility/faqArtist";
import FAQBuyer from "../pages/utility/faqBuyer";
import TermsConditions from "../pages/utility/termsConditions";
import PrivacyPolicy from "../pages/utility/privacyPolicy";
import PurchasePayments from "../pages/utility/purchasePayments";
import ShippingOutsideIndia from "../pages/utility/shippingOutsideIndia";
import ShippingIndia from "../pages/utility/shippingIndia";
import SearchBox from "../pages/utility/searchBox";
import UnSubscribe from "../pages/utility/unsubscribe";
import EditorComponent from "../component/editorComponent" // Import the editor component


// Add other admin-specific imports...

const UtilityRoutes = () => {
  return (
    <>
        <Route path="/shippingReturns" element={<ShippingReturns />} />
        <Route path="/packagingDeliveryPolicy" element={<PackagingDeliveryPolicy />} />
        <Route path="/faqArtist" element={<FAQArtist />} />
        <Route path="/faqBuyer" element={<FAQBuyer />} />
        <Route path="/termsConditions" element={<TermsConditions />} />
        <Route path="/privacyPolicy" element={<PrivacyPolicy />} />
        <Route path="/purchasePayments" element={<PurchasePayments />} />
        <Route path="/shippingOutsideIndia" element={<ShippingOutsideIndia />} />
        <Route path="/shippingIndia" element={<ShippingIndia />} />
        <Route path="/searchBox" element={<SearchBox />} />
        <Route path="/unsubscribe" element={<UnSubscribe/>} />
        
      
        {/* Route for CKEditor demo */}
        <Route path="/editorComponent" element={<EditorComponent />}></Route>
        {/* Add other admin routes here */}
    </>
  );
};

export default UtilityRoutes;
